import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { updateProfile } from "firebase/auth";
import UserForm from "../../../../Components/Form/UserForm";
import { showSuccessToast, showErrorToast } from "../../../../toastmsg";
import { getUserFields } from "../../../../formSchemas/userSchemas";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userRef = doc(db, "users", id!);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setInitialData({ id: userSnap.id, ...userSnap.data() });
        } else {
          showErrorToast("User not found");
          navigate("/user-listing");
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        showErrorToast("Failed to fetch user data");
        navigate("/user-listing");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchUser();
  }, [id, navigate]);

  const handleUpdate = async (formData: any) => {
    setSubmitting(true);
    try {
      const { firstName, lastName, role, displayName, branch } = formData;
      // const { name, role } = formData;

      await updateDoc(doc(db, "users", id!), {
        firstName,
        lastName,
        displayName,
        role,
        branch: branch || "", // ✅ Update branch field
        updatedAt: new Date(),
      });

      const currentUser = auth.currentUser;
      if (currentUser && currentUser.uid === id) {
        await updateProfile(currentUser, { displayName: firstName });
        // await updateProfile(currentUser, { displayName: name });
      }

      showSuccessToast("User updated successfully");
      navigate("/user-listing", { state: { refresh: true } });
    } catch (error) {
      console.error("Update failed:", error);
      showErrorToast("Failed to update user");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="p-4">Loading...</div>;

  // ✅ Build edit-friendly version of the schema
  const editUserFields = getUserFields
    .filter((f) => f.name !== "password" && f.name !== "confirmPassword")
    .map((field) =>
      field.name === "email" ? { ...field, disabled: true } : field
    );

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Edit User</h2>
      <UserForm
        fields={editUserFields} // Uses userSchemas schema directly
        initialData={initialData}
        onSubmit={handleUpdate}
        onCancel={() => navigate("/user-listing")}
        disabled={submitting}
      />
    </div>
  );
};

export default EditUser;
